module.exports = __webpack_public_path__ + "assets/icons/ic_co2_24px.svg";